import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Add useNavigate
import { Dropdown } from "react-bootstrap";
import logo from "./img/logo3.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPlus, faSearch } from "@fortawesome/free-solid-svg-icons"; // Add search icon
import Swal from "sweetalert2"; // Import SweetAlert2


import {Home, Search, Menu, LogIn} from "react-feather"; 
import SearchDropdown from "./SearchDropdown";
 

function NavbarVisitor() {  

  const [visitorName, setVisitorName] = useState(
    localStorage.getItem("visitor_name")
  );
  const [visitorId, setVisitorId] = useState(
    localStorage.getItem("visitor_id")
  );
  const [visitorEmail, setVisitorEmail] = useState(
    localStorage.getItem("visitor_email")
  );

  const location = useLocation();
  const navigate = useNavigate(); // Initialize navigate function

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from your account!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log out!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("visitor_name");
        localStorage.removeItem("visitor_id");
        localStorage.removeItem("visitor_email");
        window.location.href = "/";
      }
    });
  };

  // const handleSearchClick = () => {
  //   localStorage.setItem("searchUrl", window.location.href);   
  //   navigate("/search"); // Navigate to the search page
  // };



  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const handleSearchClick = () => {
    setDropdownOpen(true);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest(".search-container")) {
      setDropdownOpen(false);
    }
  };

  // Add event listener to close dropdown when clicking outside
  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  return (
    <>
      <section className="bg-white sticky-top apal">
        <div className="container-fluid">
          <div className="row py-2 align-items-center">
            <div className="col-xl-5 col-12 align-items-center d-flex justify-content-center">
              <Link className="navbar-brand text-white" to="/">
                <img src={logo} alt="Logo" className="img-fluid logocls" />
              </Link>

              {/* Input with Search Icon */}
              <SearchDropdown/>
            </div>

            <div className="col-md-7 col-12 text-end hide-on-mobile">
              <div className="d-flex justify-content-end align-items-center">
                {/* <span className="m-lf ft-menu ">
                  <Link to="/events" className="hvmenu">
                    Events
                  </Link>
                </span> */}
                <span className="m-lf ft-menu ">
                  <Link to="/filter/country/India" className="hvmenu">
                    Exhibitions
                  </Link>
                </span>
                <span className="m-lf ft-menu">
                  <Link to="/all-conference" className="hvmenu">
                    Conference
                  </Link>
                </span>

                <span className="m-lf ft-menu">
                  <Link to="/workshops" className="hvmenu">
                    Workshops
                  </Link>
                </span>

                <span className="m-lf ft-menu">
                  <Link to="/concerts" className="hvmenu">
                    Concerts
                  </Link>
                </span>

                <span className="m-lf ft-menu">
                  <Link to="/sports" className="hvmenu">
                    Sports
                  </Link>
                </span>

                
                <span className="m-lf ft-menu">
                  <Link to="/news" className="hvmenu">
                    News
                  </Link>
                </span>



                {/* <span className="m-lf ft-menu">
                  <a href="https://blog.evventoz.com/" target="_blank" className="hvmenu">
                    Blog
                  </a>
                </span> */}



                {visitorId ? (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      id="dropdown-custom-components"
                      className="btnnsmall m-left me-2"
                    >
                      {visitorName}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item as={Link} to="/my-events">
                        My Event
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/profile">
                        Profile
                      </Dropdown.Item>
                      <Dropdown.Item as="button" onClick={handleLogout}>
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <span className="btnnsmall m-left mx-2">
                    <Link to="/login" className="px-4 me-2">
                      Sign In
                    </Link>
                  </span>
                )}

                <span>
                  <a
                    href="https://app.evventoz.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="m-lf ft-menu bg-gradient-primary rrte jiau text-white"
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    &nbsp;Add Event
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>

{/* <div className="apal">
<div className="container py-2">
  <div className="d-flex">
  <span className="m-lf ft-menu me-3">
                  <Link to="/exhibitions" className="hvmenu">
                    Exhibition
                  </Link>
                </span>
                <span className="m-lf ft-menu me-3">
                  <Link to="/all-conference" className="hvmenu">
                    Conference
                  </Link>
                </span>

                <span className="m-lf ft-menu me-3">
                  <Link to="/workshops" className="hvmenu">
                    Workshop
                  </Link>
                </span>

                <span className="m-lf ft-menu me-3">
                  <Link to="/concerts" className="hvmenu">
                    Concert
                  </Link>
                </span>

                <span className="m-lf ft-menu me-3">
                  <Link to="/sports" className="hvmenu">
                    Sports
                  </Link>
                </span>

  </div>

</div>
</div> */}

      </section>

      {/* {location.pathname === "/" && (
        <section className="bg-light hide-on-mobile">
          <div className="container">
            <div className="row py-2 align-items-center">
              <div className="col-md-12 text-center">
                <div className="d-flex justify-content-center">
                  <div className="me-2">
                    Transform your event experience with smooth and effortless
                    management. Start Your{" "}
                  </div>

                  <div className="text-end">
                    <a
                      href="https://app.evventoz.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="m-lf ft-menu bg-gradient-primary rrte jiau">
                        Free Trial Today
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )} */}


<div className="footer bg-white shadow mt-auto border-top hide-on-desktop">
    <div className="d-flex align-items-center justify-content-between py-1">
      <Link to="/" className="link-dark text-center col py-0 p-1">
        <Home />
        <p className="small m-0 pt-1 text-center">Home</p>
      </Link>
      {/* <Link to="/all-events" className="text-muted text-center col py-0 p-1">
      <Menu />
        <p className="small m-0 pt-1 text-center">Events</p>
      </Link> */}


      <Link to="/search" className="text-muted text-center col py-0 p-1">
      <Search />
        <p className="small m-0 pt-1 text-center">Search</p>
      </Link>

      
      <Link to="/login" className="text-muted text-center col py-0 p-1" >
      <LogIn />
    <p className="small m-0 pt-1 text-center">Login</p>
</Link>

 


    </div>
  </div>


    </>
  );
}

export default NavbarVisitor;
